<template>
<div class="findpassword" id="">  
  <XR-head titleText="绑定手机号" :leftShow="false" :rightShow="false" ref="head"></XR-head>
  <div class="login-form">
  <mu-row gutter>
    <mu-col width="100" tablet="100" desktop="33">
      <mu-text-field label="手机号" type="number" icon=":fa fa-phone" labelFloat fullWidth :disabled="isTestPhone" v-model="bindInfo.mobile" />
    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="70" tablet="75" desktop="33">
      <mu-text-field label="短信验证码" helpText="点击右侧按钮获取，3分钟内有效" icon=":fa fa-envelope-o" labelFloat fullWidth v-model="bindInfo.code" />
    </mu-col>
    <mu-col width="30" tablet="25" desktop="33">      
      <mu-raised-button :label="smsBtnText" class="sms-button" @click="getSmsCode()" secondary/>   
    </mu-col>
  </mu-row>
  <mu-row gutter v-if="isTj && !isOnlyRead">
    <mu-col width="100" tablet="100" desktop="33">
      <mu-text-field label="邀请码" type="text" helpText="请输入推荐人的邀请码" icon=":fa fa-salesman2" labelFloat fullWidth v-model="bindInfo.Recommend" />
    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="100" tablet="50" desktop="33" class="login-div">
      <mu-raised-button label="绑 定" class="demo-raised-button" primary fullWidth @click="getMobileInfo(true)" />
    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="100" tablet="50" desktop="33" class="div3">
      <XR-toast @onClose="goBack" ref="XRtoast"></XR-toast>
    </mu-col>
  </mu-row>
  
  <mu-dialog :open="dialog" title="同步账号数据" @close="closeDialog">
    <mu-content-block class="notice">用户已存在，绑定将同步该手机账号的用户数据</mu-content-block>
    <mu-flat-button slot="actions" @click="closeDialog" primary label="取消"/>
    <mu-flat-button slot="actions" primary @click="submit" label="确定"/>
  </mu-dialog>
</div>
</div>
</template>
<script>
 
export default {
  data () {
    return {
      isTj:false,
      isTestPhone : false,
      isSms:false,
      bindInfo:{
        mobile :'',
        code:'',
        Recommend:''
      },
      smsBtnText:'获取短信',      
      dialog : false,
      bindUserName:'',
      isOnlyRead:false,
    }
  },
  mounted(){
    this.$postBase(
      this.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
      ).then(function(res) {
      if(!res.IsSuccess){
          //ths.$refs.XRtoast.failed(res.Msg, true)
      }else{
          wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.Data.AppId, // 必填，公众号的唯一标识
              timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
              nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
              signature: res.Data.Sign, // 必填，签名，见附录1
              jsApiList: [] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function () {
              WeixinJSBridge.call('hideOptionMenu');
          });
      }
    });
    this.getMemberInfo()
  },
  methods: {
    getMemberInfo(){           
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserInfo"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.loaded =false          
          ths.$refs.XRtoast.hide()
          ths.bindInfo.mobile=res.Data.mobile
          ths.isTestPhone = res.Data.IsTestPhone
          if (ths.bindInfo.mobile){
            ths.$refs.XRtoast.failed("手机号已绑定", true)
            ths.$router.push('/usercenter/index')
          } else {
            ths.getSalesmanInfo();
          }          
        }
      });      
    },
    getSalesmanInfo(){
      var ths = this;   
      ths.$post(
        "/Shop/SalesmanServer/GetSalesmanInfo"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{
          if (res.Data.tjrbm == '111760800981945' && !ths.isTestPhone){
            ths.isTj = true;
          }          
        }
      });
    },
    getMobileInfo(isOpen){
      if (isOpen){
        if (this.isTj && !this.bindInfo.Recommend){
          this.$refs.XRtoast.failed("请输入推荐人的邀请码", true)
          return;
        }
      }

      var ths = this;
      ths.$post(
        "/Shop/UserServer/GetMobileInfo", {"mobile": this.bindInfo.mobile}
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.isOnlyRead = false;
          if (isOpen){
            ths.submit();
          }
        }else{
          ths.isOnlyRead = true;
          ths.bindInfo.Recommend = res.Data;
          if (isOpen){
            ths.dialog = true;
          }          
        }
      });

    },
    submit: function () {
      this.dialog = false;

      if (this.isTj && !this.bindInfo.Recommend){
        this.$refs.XRtoast.failed("请输入推荐人的邀请码", true)
        return;
      }

      var ths = this;   
      ths.$post(
        "/Shop/UserServer/BindMobile",
        JSON.stringify(this.bindInfo)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{
          if (res.Data){
            ths.$store.dispatch('SetUser', res.Data)
          }
          ths.$refs.XRtoast.success(res.Msg, true)
          ths.$router.push('/usercenter/index')
        }
      });
    },
    getSmsCode: function(){
      var ths = this;   
        if(!ths.isSms){
          ths.$post(
            "/Shop/UserServer/BindMobileSendSms",
            JSON.stringify(this.bindInfo)
          ).then(function(res) {
            ths.$refs.XRtoast.hide()
            ths.getMobileInfo(false);
            if(!res.IsSuccess){
              ths.$refs.XRtoast.failed(res.Msg, true)
            }else{          
              ths.isSms = true;
              ths.smsBtnText = res.Data * 60;
              var interval = setInterval(function(){
                if(ths.smsBtnText >0){
                  ths.smsBtnText--
                  ths.isSms = true;
                }else{                  
                  ths.isSms = false;
                  ths.smsBtnText = '获取短信'
                  clearInterval(interval)
                }
              }, 1000)  
            }
        });
      }
    },
    goToMove(){
      this.$router.push('/usercenter/mobileMove?mobile='+this.bindInfo.mobile+'&'+'userName='+this.bindUserName)
    }, 
    goBack(){
      this.$router.goBack()
    },    
    openDialog () {
      this.dialog = true
    },
    closeDialog () {
      this.bindInfo.mobile = ''
      this.dialog = false
    }
  }
}

</script>
<style>
.findpassword{
  background: white;
}
.findpassword .login-form {
  padding: 10px 20px 20px 10px;
}
.findpassword .login-div {
  padding: 40px 0px 0 20px;
}
.findpassword .demo-raised-button {
  height: 50px;
}
.findpassword .div2 {
  padding: 20px 0 0 0;
}
.findpassword .demo-flat-button.right {
  float: right;
}
.findpassword .div3 {
  text-align: center;
  position: absolute;
  bottom: 40px;
  left: 0;
}
.findpassword .findpassword .notice{
  font-size: 12px;
}
.findpassword .sms-button{
  margin-top: 28px;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/mobileBind.vue